export default __webpack_public_path__ + "static/media/vtex-footer.dab2e640.svg";